import {
    LOADING_COMPLETED_STATE,
    LOADING_NON_BLOCKING_ANOMALY
} from "../constants";

export default {
    methods: {
        getLoading(loading) {
            if (loading === LOADING_COMPLETED_STATE) {
                return "load";
            } else if (loading === LOADING_NON_BLOCKING_ANOMALY) {
                return "anomaly";
            } else {
                return "in-progress";
            }
        },
        getLoadingIcon(loading) {
            switch (loading) {
                case LOADING_COMPLETED_STATE:
                    return "check-bold";
                case LOADING_NON_BLOCKING_ANOMALY:
                    return "exclamation-thick";
                default:
                    return "timer-sand"
            }
        },
    }
}
